import { IPersonalDetails } from 'API/personalDetails';
import { useImposter } from 'Hooks';

export const useDisabilityCertAccess = () => {
  const { authenticatedUser, imposterId, fakeUser } = useImposter();

  let user: IPersonalDetails | undefined;

  if (imposterId) {
    user = fakeUser as IPersonalDetails;
  } else if (authenticatedUser) {
    user = authenticatedUser as IPersonalDetails;
  }

  const hasAccess =
    user &&
    user.caseNumber &&
    user.disabilityPercent &&
    parseInt(user.disabilityPercent) >= 10;

  return { hasAccess };
};
